import script from "./ShowCaseQueue.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowCaseQueue.vue?vue&type=script&setup=true&lang=js"

import "./ShowCaseQueue.vue?vue&type=style&index=0&id=5218cf49&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5218cf49"]])

export default __exports__